
export interface IPicture {
    picture_id: string,
    tags: string[],
    url: string,
}

export class Pictures {
    constructor(public readonly data: { [key: string]: IPicture }) {
        //
    }

    filter(tags: string[]): IPicture[] {
        return Object.values(this.data).filter(it => tags.slice(1).every(t => it.tags.includes(t)));
    }
}
